import type { SearchVehicle } from '../types'

export const daysOnLot = ({ daysOnLot: _daysOnLot }: SearchVehicle): string => _daysOnLot || ''
